module.exports = __webpack_public_path__ + "static/media/report_confused.0b028731.svg";